import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FiltrosMultiSelect } from 'src/app/comercial/reportes/reporte-ventas/domain/reporte-ventas.request';
import { ReporteClientesAnioEtaDetalleRequest } from 'src/app/reporte-ciclo-embarque/domain/reporte-ciclo-embarque-request';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';

@Component({
    selector: 'app-reporte-pareto-vendedor',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        AccordionModule
    ],
    templateUrl: './reporte-pareto-vendedor.component.html',
    styleUrl: './reporte-pareto-vendedor.component.css'
})
export class ReporteParetoVendedorComponent {

  constructor(
    private readonly servReportes: ReportesRepository,
    private readonly util: UtilService,
    private readonly storage: StorageService
  ) { }

  metadatatable3: newmetadate[] = [
    { field: 'vendedor', title: 'Vendedor', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'cartera', title: 'Universo Cartera', inputType: 'int', rowFooter: 'sum' },
    { field: 'cliente', title: 'cliente efectivo', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus', title: 'teus', inputType: 'int', rowFooter: 'sum' },
    { field: 'ochenta', title: '80%', inputType: 'text', rowFooter: 'sum' },
    { field: 'teus_ochenta', title: 'TEUS 80%', inputType: 'text', rowFooter: 'sum' },
    { field: 'veinte', title: '20%', inputType: 'text', rowFooter: 'sum' },
    { field: 'teus_veinte', title: 'TEUS 20%', inputType: 'text', rowFooter: 'sum' }
  ]

  metadatatable4: newmetadate[] = [
    { field: 'vendedor', title: 'Vendedor', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'cliente', title: 'cliente efectivo', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'teus', title: 'teus', inputType: 'int', rowFooter: 'sum' },
    { field: 'mandato', title: 'TEUS MANDATO', inputType: 'int', rowFooter: 'sum' },
    { field: 'otrostraficos', title: 'TEUS OTROS TRAFICOS', inputType: 'int', rowFooter: 'sum' },
    { field: 'exportaciones', title: 'EXPORTACIONES', inputType: 'int', rowFooter: 'sum' },
    { field: 'ochenta', title: '80%', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'veinte', title: '20%', inputType: 'text', style: { align: 'left', justify: 'left' } }

  ]

  metadataReporteDetalleClientesDetalle: newmetadate[] = [
    { field: 'cliente', title: 'Cliente', inputType: 'text', style: { justify: 'left' } },
    { field: 'ejecutivo', title: 'ejecutivo', inputType: 'text', style: { justify: 'left' } },
    { field: 'enero', title: 'ene', inputType: 'int', rowFooter: 'sum' },
    { field: 'febrero', title: 'feb', inputType: 'int', rowFooter: 'sum' },
    { field: 'marzo', title: 'mar', inputType: 'int', rowFooter: 'sum' },
    { field: 'abril', title: 'abr', inputType: 'int', rowFooter: 'sum' },
    { field: 'mayo', title: 'may', inputType: 'int', rowFooter: 'sum' },
    { field: 'junio', title: 'jun', inputType: 'int', rowFooter: 'sum' },
    { field: 'julio', title: 'jul', inputType: 'int', rowFooter: 'sum' },
    { field: 'agosto', title: 'ago', inputType: 'int', rowFooter: 'sum' },
    { field: 'septiembre', title: 'sep', inputType: 'int', rowFooter: 'sum' },
    { field: 'octubre', title: 'oct', inputType: 'int', rowFooter: 'sum' },
    { field: 'noviembre', title: 'nov', inputType: 'int', rowFooter: 'sum' },
    { field: 'diciembre', title: 'dic', inputType: 'int', rowFooter: 'sum' },
    { field: 'total', title: 'total', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia', title: 'Frecuencia', inputType: 'int', rowFooter: 'sum' }
  ]


  metadataReporteDetalleClientesDetalle02: newmetadate[] = [
    { field: 'ejecutivo', title: 'ejecutivo', inputType: 'text', style: { justify: 'left' } },
    { field: 'frecuencia1', title: 'frec 01', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus1', title: 'Teus frec 01', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia2', title: 'frec 02', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus2', title: 'Teus frec 02', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia3', title: 'frec 03', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus3', title: 'Teus frec 03', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia4', title: 'frec 04', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus4', title: 'Teus frec 04', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia5', title: 'frec 05', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus5', title: 'Teus frec 05', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia6', title: 'frec 06', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus6', title: 'Teus frec 06', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia7', title: 'frec 07', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus7', title: 'Teus frec 07', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia8', title: 'frec 08', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus8', title: 'Teus frec 08', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia9', title: 'frec 09', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus9', title: 'Teus frec 09', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia10', title: 'frec 10', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus10', title: 'Teus frec 10', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia11', title: 'frec 11', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus11', title: 'Teus frec 11', inputType: 'int', rowFooter: 'sum' },
    { field: 'frecuencia12', title: 'frec 12', inputType: 'int', rowFooter: 'sum' },
    { field: 'teus12', title: 'Teus frec 12', inputType: 'int', rowFooter: 'sum' },
    { field: 'total', title: 'TOTAL', inputType: 'int', rowFooter: 'sum' },
    { field: 'teustotal', title: 'Teus Total', inputType: 'int', rowFooter: 'sum' },
  ]

  group: FormGroup
  onInitForm() {
    this.group = new FormGroup({
      anio: new FormControl(null, null),
      regimen: new FormControl(null, null),
      lineanegocio: new FormControl(null, null)
    })
  }

  ListaAnios: any[] = []
  ListaRegimen: any[] = []
  ListaLineaNegocio: any[] = []
  getParameters() {
    this.ListaAnios = this.util.getAnios()
    this.ListaRegimen = this.util.getParameterByType("RGM")
    this.ListaLineaNegocio = this.util.getParameterByType("LNG")
    this.ListaLineaNegocio = this.ListaLineaNegocio.filter(r => r.label !== 'SERVICIO INTEGRADO LOCAL' && r.label !== 'SEGUROS' && r.label !== 'SERVICIO LOGISTICO INTEGRAL')
  }

  rol: number = 0
  ngOnInit(): void {
    this.rol = parseInt(this.storage.get('rol'))
    this.getParameters()
    this.onInitForm()
    this.group.get('anio').setValue((new Date()).getFullYear())
    this.search()
  }

  paretoVendedorResumen: any[] = []
  paretoVendedorDetalle: any[] = []
  dataReporteFrecuenciaClientesDetalle: any[] = []
  dataReporteFrecuenciaClientesDetalle02: any[] = []
  search() {

    const request = <ReporteClientesAnioEtaDetalleRequest>{}
    const anios: FiltrosMultiSelect[] = []
    const values = this.group.value

    if (values.anio) {
      const item: FiltrosMultiSelect = {
        filt_codigoint: parseInt(values.anio),
        filt_codigovar: '',
        filt_nombre: ''
      }
      anios.push(item)
    }

    request.anio = anios
    request.regimen = values.regimen ? values.regimen.nombre : ''
    request.lineanegocio = values.lineanegocio ? values.lineanegocio.nombre : ''

    if (this.charEjecuticosPorcentaje instanceof Chart) {
      this.charEjecuticosPorcentaje.destroy();
    }

    this.paretoVendedorDetalle = []
    this.paretoVendedorResumen = []
    this.dataReporteFrecuenciaClientesDetalle = []
    this.dataReporteFrecuenciaClientesDetalle02 = []

    this.listaEjecutivos = []
    this.listaOchenta = []
    this.listaVeinte = []

    request.tiporeporte = 3

    this.servReportes.ReporteParetodeCarteraResumen(request).subscribe(response => {
      this.paretoVendedorResumen = response.datos.result
      this.paretoVendedorResumen.forEach(r => {
        this.listaEjecutivos.push(r.vendedor.toUpperCase() || '')
        this.listaOchenta.push(r.ochenta)
        this.listaVeinte.push(r.veinte)
      })
      this.generateChart()
    })

    request.tiporeporte = 5
    this.servReportes.ReporteParetodeCarteraDetalle(request).subscribe(response => {
      this.paretoVendedorDetalle = response.datos.result
    })

    request.tiporeporte = 12
    this.servReportes.ReporteFrecuenciaClienteDetalle(request).subscribe(response => {
      this.dataReporteFrecuenciaClientesDetalle = response.datos.result
    })

    request.tiporeporte = 14
    this.servReportes.ReporteFrecuenciaClienteDetalle(request).subscribe(response => {
      this.dataReporteFrecuenciaClientesDetalle02 = response.datos.result
    })

  }

  listaEjecutivos: any[] = []
  listaOchenta: any[] = []
  listaVeinte: any[] = []
  charEjecuticosPorcentaje: any
  generateChart() {

    let pc = true;

    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) { pc = false; } else { pc = true; }

    this.charEjecuticosPorcentaje = new Chart('chartEjecutivosxPorcentaje01', {
      type: 'bar',
      data: {
        xLabels: this.listaEjecutivos,
        datasets: [
          {
            label: 'OCHENTA',
            data: this.listaOchenta,
            barPercentage: 1,
            borderRadius: 5,
            borderColor: 'rgb(28, 237, 114, 0.5)',
            tension: 0.4,
            backgroundColor: 'rgb(28, 237, 114, 0.5)',
            borderWidth: 0,
            datalabels: {
              color: 'black',
              font: {
                weight: 'bold',
                size: 10
              },
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
            }
          },
          {
            label: 'VEINTE',
            data: this.listaVeinte,
            barPercentage: 1,
            borderRadius: 5,
            borderColor: 'rgb(28, 209, 237 , 0.5)',
            tension: 0.4,
            borderWidth: 0,
            backgroundColor: 'rgb(28, 209, 237 , 0.5)',
            datalabels: {
              color: 'black',
              font: {
                weight: 'bold',
                size: 10
              },
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
            }
          }
        ],

      },
      plugins: [ChartDataLabels],
      options: {
        scales: {
          x: {
            ticks: {
              font: {
                size: 9,
                weight: '500'
              },
              color: 'black',
              maxRotation: 90,
              minRotation: 90
            },
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,

          }
        },
        aspectRatio: 3 / 1.5,
        responsive: true,
        interaction: {
          mode: 'point',
          intersect: false,
        },
        plugins: {
          filler: {
            propagate: false
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: pc == true ? 8 : 6,
                weight: '500'
              },
              color: 'black',
            },
          },
          datalabels: {
            anchor: 'end',
            formatter: function (value, context) {
              const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true,
                style: 'decimal'
              };
              const formattedValue = value.toLocaleString('es-PE');
              return formattedValue;
            },
          },

        },
        elements: {
          line: {
            fill: false,
            tension: 0.4,
            borderWidth: 0.1,
          },
          point: {
            hoverRadius: 15,
          },
        }
      }
    });

  }
}
